import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import { heroData } from "../../mocks/cancelPolicyData";
import PolicySection from "./components/PolicySection";
import WeatherSection from "./components/WeatherSection";
import NotesSection from "./components/NotesSection";

export default function CancelPolicy() {
  return (
    <PageLayout>
      <InfoPageHero
        label={heroData.label}
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="キャンセルポリシー"
      />
      <PolicySection />
      <WeatherSection />
      <NotesSection />
      <InfoPageFinalCTA
        title={`ご予約の前に\nキャンセル規定をご確認ください`}
        subtitle="安心してお申し込みいただくため、あらかじめご確認をお願いいたします"
        ctas={[
          {
            label: "ご予約の流れを見る",
            href: "/booking-flow",
            type: "primary",
          },
          {
            label: "お問い合わせ",
            href: "/contact",
            type: "secondary",
          },
        ]}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
